// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Button, Popover, PopoverContainer } from '@gandi/ui';

import { useExtendedSuggestion } from '../../DomainCreate/components/ProvidedArea/modules';

import styles from './RestrictionPopOver.scss';

type Props = {
  fqdn: string,
};

function RestrictionPopOver({ fqdn }: Props) {
  const { __ } = useTranslator();

  const { suggestion } = useExtendedSuggestion({ fqdn });

  if (!suggestion || !suggestion.restriction) return null;

  return (
    <PopoverContainer
      id={`${fqdn}-restriction-popover`}
      placement="bottom"
      behaviour="click"
      renderReference={getReferenceProps => (
        <Button
          iconBefore="infoWire"
          kind="outline"
          small
          weight="regular"
          size="small"
          className={styles.root}
          {...getReferenceProps()}
        >
          {__('view conditions')}
        </Button>
      )}
    >
      {getPopoverProps => (
        <Popover {...getPopoverProps()}>
          <Base
            tagName="p"
            margin="none"
            dangerouslySetInnerHTML={{ __html: suggestion.restriction }}
          />
        </Popover>
      )}
    </PopoverContainer>
  );
}

export default (React.memo<Props>(
  RestrictionPopOver,
  () => true,
): React.ComponentType<Props>);
